import { RoomDetailsApiDTO } from "../dtos";
import { RoomDetails } from "@/models";

export const mapRoomDetailsApiDTOtoRoomDetails = (
  roomDetailsDTO: RoomDetailsApiDTO["data"]
): RoomDetails => {
  return {
    name: roomDetailsDTO?.name,
    noiseSettings: {
      low: roomDetailsDTO?.noiseSettings?.low,
      medium: roomDetailsDTO?.noiseSettings?.medium,
      high: roomDetailsDTO?.noiseSettings?.high,
    },
    location: {
      lat: roomDetailsDTO?.location?.lat,
      lng: roomDetailsDTO?.location?.lng,
    },
    address: roomDetailsDTO?.address,
    phone: roomDetailsDTO?.phone,
    phoneSMS: roomDetailsDTO?.phoneSMS,
    timezone: {
      name: roomDetailsDTO?.timezone?.name,
      label: roomDetailsDTO?.timezone?.label,
    },
    licenseId: roomDetailsDTO?.licenseId,
    serviceContractId: roomDetailsDTO?.serviceContractId,
    device: roomDetailsDTO?.device
      ? {
          monitorId: roomDetailsDTO.device.monitorId,
          firmware: roomDetailsDTO.device.firmware,
          data: roomDetailsDTO.device.data
            ? {
                level: roomDetailsDTO.device.data.level,
                value: roomDetailsDTO.device.data.value,
                updatedAt: roomDetailsDTO.device.data.updatedAt,
                wifi: roomDetailsDTO.device.data.wifi,
                quality: roomDetailsDTO.device.data.quality,
                localip: roomDetailsDTO.device.data.localip,
              }
            : undefined,
        }
      : undefined,
  };
};
